<div [ngStyle]="{'width': width, 'height':height}" class="avatar__container">
	<div class="avatar">
		<!-- The letters -->
		{{username.substring(0,2)}}
	</div>
</div>